import {useEffect} from "react";
export default (func) => useEffect(func, [])
